import pickemLogoROC from '@/assets/bet99-logo-roc.svg';
import pickemLogoOn from '@/assets/bet99-logo-on.svg';

export type GameLogoProps = {
  location: string;
  className?: string;
};

export const GameLogo = ({ location, className }: GameLogoProps) => {
  const logo = location === 'ca' ? pickemLogoROC : pickemLogoOn;

  return <img data-test-id="app-logo" src={logo} alt="PICK'EM" className={className} />;
};
